import { render, staticRenderFns } from "./Renouvellement.vue?vue&type=template&id=ed2ea67a&scoped=true"
import script from "./Renouvellement.vue?vue&type=script&lang=ts"
export * from "./Renouvellement.vue?vue&type=script&lang=ts"
import style0 from "./Renouvellement.vue?vue&type=style&index=0&id=ed2ea67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2ea67a",
  null
  
)

export default component.exports